module.exports = __webpack_public_path__ + "img/addPic.df8dbea8.webp";